import React, { useState, useEffect } from "react";

const StartAProject = () => {
  const [formData, setFormData] = useState({
    name: "",
    gmail: "",
    companyName: "",
    service: "How did you hear about us?",
    messages: "",
  });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);

  const dropdownOptions = [
    "Clutch",
    "Google Search",
    "Someone in my network",
    "G2",
    "Other",
  ];

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOptionSelect = (option) => {
    setFormData({ ...formData, service: option });
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.matches(".dropbtn") &&
        !event.target.closest(".dropdown")
      ) {
        setIsDropdownOpen(false);
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      inquiryData: {
        email: formData.gmail,
        name: formData.name,
        message: formData.messages,
        company: formData.companyName,
        service: formData.service,
      },
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        "https://us-west1-slashstar-co.cloudfunctions.net/verifyCapcha",
        requestOptions
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      setShowSnackbar(true);
      setFormData({
        name: "",
        gmail: "",
        companyName: "",
        service: "How did you hear about us?",
        messages: "",
      });

      setTimeout(() => {
        setShowSnackbar(false);
        document.body.classList.remove("open-modal");
      }, 5000);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="start-a-project-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.3s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container wow fadeInUp" data-wow-delay="0.3s">
            <h1>Start A Project</h1>
          </div>
        </div>
      </section>

      <section className="projects-section">
        <div className="container">
          <div className="projects-main">
            <div className="projects-content wow fadeInUp">
              <div className="title-small wow fadeInUp">
                <span>START A PROJECT</span>
              </div>
              <div className="title wow fadeInUp">
                <div>
                  <h2>
                    Let's Start A <br />{" "}
                    <span className="gradient-text">Project Together</span>
                  </h2>
                </div>
                <div>
                  <p>
                    Fill in this quick form to tell us about your needs, and one
                    of our friendly Product Consultants will reach out to arrange
                    a time chat more about your project. (We're excited already.)
                  </p>
                </div>
                <span className="outline"></span>
              </div>
            </div>
            <div className="projects-forms wow fadeInUp">
              <h3>Let's Talk About Your Project</h3>
              <form className="form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder=" "
                    className="form-control"
                    value={formData.name}
                    onChange={handleChange}
                  />
                  <label>Your Full Name</label>
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    name="gmail"
                    id="gmail"
                    placeholder=" "
                    className="form-control"
                    required
                    value={formData.gmail}
                    onChange={handleChange}
                  />
                  <label>Email Address</label>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="companyName"
                    id="companyName"
                    placeholder=" "
                    className="form-control"
                    value={formData.companyName}
                    onChange={handleChange}
                  />
                  <label>Company Name</label>
                </div>
                <div className="dropdown">
                  <button
                    type="button"
                    className="dropbtn"
                    onClick={handleDropdownToggle}
                  >
                    {formData.service}
                  </button>
                  <div
                    id="myDropdown"
                    className={`dropdown-content ${isDropdownOpen ? "show" : ""}`}
                  >
                    {dropdownOptions.map((option) => (
                      <p
                        key={option}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOptionSelect(option)}
                      >
                        {option}
                      </p>
                    ))}
                  </div>
                </div>

                <div className="form-group form-textarea">
                  <textarea
                    type="text"
                    name="messages"
                    id="messages"
                    placeholder=" "
                    className="form-control"
                    value={formData.messages}
                    onChange={handleChange}
                  ></textarea>
                  <label>Your message</label>
                </div>

                <div id="example3"></div>

                <div className="form-btn sidebar-btn btn-padding">
                  <button
                    className={`btn btn-shadow ${isSubmitting ? "loading" : ""}`}
                    type="submit"
                    id="btn"
                    disabled={isSubmitting}
                  >
                    Submit
                  </button>
                </div>
                <div id="snackbar" className={showSnackbar ? "show" : ""}>
                  Your request has been submitted successfully. <br />
                  We will reach out to you soon.
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StartAProject;
